import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=7fb4c552&scoped=true"
import script from "./Ribbon.vue?vue&type=script&lang=js"
export * from "./Ribbon.vue?vue&type=script&lang=js"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=7fb4c552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4c552",
  null
  
)

export default component.exports